import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/vip/un-member-label.png'
import _imports_1 from '@/assets/image/user/integral-mall1.png'
import _imports_2 from '@/assets/image/vip/icon-un-member.png'
import _imports_3 from '@/assets/image/user/icon-notice.png'
import _imports_4 from '@/assets/image/user/invite-banner.jpg'
import _imports_5 from '@/assets/image/user/integral-mall21.jpg'
import _imports_6 from '@/assets/image/icon/create.png'


const _withScopeId = n => (_pushScopeId("data-v-6c73da6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "user-card" }
const _hoisted_3 = { class: "user-card-header" }
const _hoisted_4 = { class: "user" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "user__name" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "username" }
const _hoisted_9 = {
  key: 0,
  class: "member-label"
}
const _hoisted_10 = {
  key: 1,
  class: "member-label"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-member-growth",
  src: _imports_0
}, null, -1))
const _hoisted_12 = { class: "member-points-box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-points",
  src: _imports_1
}, null, -1))
const _hoisted_14 = { class: "member-points" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-member",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_16 = { class: "member-points-text" }
const _hoisted_17 = {
  key: 0,
  class: "user-card-header__chaticon"
}
const _hoisted_18 = { class: "main" }
const _hoisted_19 = { class: "main-mine card" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l-box" }, null, -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 0,
  class: "change-company"
}
const _hoisted_24 = { class: "company-header" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "我的企业", -1))
const _hoisted_26 = { class: "company-main" }
const _hoisted_27 = { class: "company-left" }
const _hoisted_28 = { class: "company-left__name" }
const _hoisted_29 = { class: "company-left__days" }
const _hoisted_30 = { class: "company-toggle-btn" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 1,
  class: "no-company"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l-box" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "no-company-title" }, "添加企业 立享服务"),
  /*#__PURE__*/_createElementVNode("p", { class: "no-company-desc" })
], -1))
const _hoisted_34 = { class: "main-finance card" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-finance__title" }, "智能财税", -1))
const _hoisted_36 = { class: "main-finance-content" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_40 = ["href"]
const _hoisted_41 = ["href"]
const _hoisted_42 = { class: "main-finance card" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-finance__title" }, "服务与工具", -1))
const _hoisted_44 = { class: "main-finance-content" }
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "main-finance card" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-finance__title" }, "我的服务", -1))
const _hoisted_48 = { class: "main-finance-content" }
const _hoisted_49 = ["src"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-tips" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_6 })
], -1))

import { reactive, computed, onActivated } from 'vue'
import { useRouter } from 'vue-router'
import { Swipe, SwipeItem, Button, Dialog, Badge } from 'vant'
import MTabbar from '@/components/MTabbar/MTabbar.vue'
import { useUserStore } from '@/store/modules/user'
import {
  getChatAdvisers,
  getUnReadNum,
  getCountUserPersonalHome,
} from '@/api/user'
import { getHomeBanner, getHomeCenterBanner } from '@/api/home'
import {
  MINE,
  FINANCE,
  MY_SERVICE,
  MY_SERVICE_TOOL,
} from '@/constant/userCenter'
import MImage from '@/components/MImage/MImage.vue'
import iconGrowth from '@/assets/image/vip/un-member-label.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserCenter',
  setup(__props) {

const router = useRouter()
const userStore = useUserStore()

const state = reactive({
  chatAdvisers: {},
  finance: FINANCE,
  myService: MY_SERVICE.filter((i) => !i.auth),
  unReadNum: 0,
  equityPackageUnReadNum: '',
  bannerList: [] as any,
  centerBannerList: [] as any,
})
const validityDay = computed(() => {
  return userStore.userInfo.validityDay?.split('~')[1]
})

const myServiceList = computed(() => {
  let list = [...MY_SERVICE]
  // if (userStore.userInfo?.customerType) {
  //   list = list.filter((item) => item.label != '咨询师')
  // }
  // if (userStore.userInfo.employeeType === 0) {
  //   list = list.filter((item) => item.auth !== 'employee')
  // }
  // // 非会员或者非推广员
  // if (!userStore.userInfo.memberDto) {
  //   list = list.filter((item) => {
  //     const authList = Array.isArray(item.auth) ? item.auth : [item.auth]
  //     return !authList.includes('member')
  //   })
  // }

  list = list.filter((item) => {
    let auth = item.auth
    if (!auth) return true
    const authList = Array.isArray(auth) ? auth : [auth]
    if (auth === 'customerType') {
      return Boolean(userStore.userInfo?.customerType)
    }
    let result = false
    for (let i = 0; i <= authList.length; i++) {
      const authKey = authList[i]
      if (
        authKey === 'employee' &&
        userStore.userInfo.employeeType === 1 &&
        !result
      ) {
        result = true
        break
      }
      if (
        authKey === 'member' &&
        Boolean(userStore.userInfo?.memberDto) &&
        !result
      ) {
        result = true
        break
      }
    }
    return result
  })

  return list
})

const myServiceToolList = computed(() => {
  let list = [...MY_SERVICE_TOOL]
  if (!userStore.userInfo?.companyId) {
    list = list.filter((item) => item.auth != 'emptool')
  }
  return list
})

const wxName = computed(() =>
  userStore.userInfo.wxName?.length > 7
    ? userStore.userInfo.wxName.slice(0, 7) + '...'
    : userStore.userInfo.wxName
)

onActivated(async () => {
  await userStore.getUserInfo()
  await fetchCenterBanner()
  fetchChatAdvisers()
  fetchUnReadNum()
  fetchEquityPackageNum()
  await fetchBanner()
})

const isMemberUser = computed(() => {
  return userStore.userInfo.memberDto
})

// 仅用户绑定企业后开启邀请活动入口
const fetchBanner = async () => {
  if (!userStore.userInfo?.companyId) return false
  const { ret, dataList } = await getHomeBanner({ advertisementType: 10 })
  if (ret == 100 && Array.isArray(dataList)) {
    state.bannerList = dataList
  }
}

const fetchCenterBanner = async () => {
  const { ret, dataList } = await getHomeCenterBanner({ advertisementType: 12 })
  if (ret == 100 && Array.isArray(dataList)) {
    state.centerBannerList = dataList
  }
}

const fetchChatAdvisers = async () => {
  const {
    ret,
    dataList: [chatAdvisers],
  } = await getChatAdvisers()
  if (ret === 100) {
    state.chatAdvisers = chatAdvisers || {}
  }
}
const fetchUnReadNum = async () => {
  const { data } = await getUnReadNum()
  state.unReadNum = data
}
const fetchEquityPackageNum = async () => {
  const { ret, data } = await getCountUserPersonalHome()
  if (ret === 100) {
    state.equityPackageUnReadNum = data?.rightsPackageNotUseCount || ''
  }
}

const handleRouterLink = (path) => {
  console.log(path)
  if (!userStore.userInfo?.companyId) {
    const paths = [
      '/lnquire-tax',
      '/expert-invitation',
      '/staff-manage',
      '/service',
      '/company-info',
      '/progress',
    ]
    console.log('path==>', path)
    console.log('paths.includes(path)==>', paths.includes(path))
    if (paths.includes(path)) {
      return Dialog.confirm({
        title: '温馨提示',
        message: '您尚未绑定企业，请前往绑定。',
        confirmButtonColor: '#CB9E52',
        confirmButtonText: '绑定企业',
      })
        .then(() => {
          router.push({
            path: '/user/enterprisebinding/bindingqiye',
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
  if (path === '/service') {
    return router.push({
      path,
      query: {
        receiveUserId: state.chatAdvisers.id,
        receiveType: 1,
        phoneNumber: state.chatAdvisers.phoneNumber,
      },
    })
  }
  if (path === '/progress') {
    return router.push({
      path,
      query: { type: 1 },
    })
  }
  if (path === '/staff-manage') {
    console.log('userStore.userInfo==>', userStore.userInfo)
    return router.push({
      path,
      query: {
        id: userStore.userInfo?.id,
        hdz: userStore.userInfo?.hdzCustomerId,
        companyName: userStore.userInfo?.bingdCompanyName,
      },
    })
  }
  router.push({ path })
}
// const handleRouterToChat = () => {
//   if (userStore.userInfo.userType === 1 && !userStore.userInfo.companyId) {
//     if (!state.chatAdvisers) return Toast('您的财税专家还未上线')
//     return router.push({
//       path: '/service',
//       query: { receiveUserId: state.chatAdvisers.id },
//     })
//   }
//   console.log('state.chatAdvisers.id=>', state.chatAdvisers.id)
//   router.push({
//     path: '/service',
//     query: { receiveUserId: state.chatAdvisers.id, receiveType: 1 },
//   })
// }
const handleRouterMember = () => {
  console.log('handleRouterMember==>')
  if (userStore.userInfo.phoneNumber) {
    router.push({ path: '/invite-member' })
  } else {
    router.push({
      path: '/user/settings/update',
      query: { path: '/invite-member' },
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/user/settings" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "avatar",
                  src: _unref(userStore).userInfo.headImgUrl
                }, null, 8, _hoisted_5)
              ]),
              _: 1
            }),
            (_unref(isMemberUser))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "renewal",
                  to: "/member/pay"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 续费 ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(wxName)), 1),
                (_unref(isMemberUser))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      (_unref(userStore).userInfo?.memberDto?.isValiddMember)
                        ? (_openBlock(), _createBlock(MImage, {
                            key: 0,
                            class: "icon-member-tag",
                            src: _unref(userStore).userInfo?.memberDto?.memberIcon,
                            alt: "",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/member/home')))
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_router_link, { to: "/member/detail" }, {
                        default: _withCtx(() => [
                          _createVNode(MImage, {
                            class: _normalizeClass(["icon-member-growth", {
                      expire: !_unref(userStore).userInfo?.memberDto?.isValiddMember,
                    }]),
                            src: 
                      _unref(userStore).userInfo?.growthDto?.growthIcon || _unref(iconGrowth)
                    
                          }, null, 8, ["class", "src"])
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _createVNode(_component_router_link, { to: "/member/detail" }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              (
                _unref(isMemberUser) && _unref(userStore).userInfo?.memberDto?.isValiddMember
              )
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/my/integral/1"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("span", _hoisted_14, " 积分：" + _toDisplayString(_unref(userStore).userInfo?.integral), 1)
                      ])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    class: "member-points-box",
                    to: "/member/pay"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(userStore).userInfo?.memberDto &&
                !_unref(userStore).userInfo?.memberDto?.isValiddMember
                  ? '会员已过期，开通中财捷会员'
                  : '开通中财捷会员'), 1)
                    ]),
                    _: 1
                  }))
            ])
          ]),
          _createElementVNode("img", {
            class: "user-card-header__chat",
            src: _imports_3,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleRouterLink('/message-list')))
          }),
          (state.unReadNum)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MINE), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.label,
              class: "main-mine__item",
              onClick: ($event: any) => (handleRouterLink(item.path))
            }, [
              _createElementVNode("img", {
                src: item.icon
              }, null, 8, _hoisted_22),
              _createElementVNode("span", null, _toDisplayString(item.label), 1)
            ], 8, _hoisted_21))
          }), 128))
        ]),
        (_unref(userStore).userInfo.bingdCompanyName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_router_link, {
                  class: "r-control",
                  to: { name: 'binding-list' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 立即绑定 ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(userStore).userInfo.bingdCompanyName), 1),
                  _createElementVNode("div", _hoisted_29, "服务期限：" + _toDisplayString(_unref(validityDay)), 1)
                ]),
                _createVNode(_component_router_link, { to: "/change-company" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("img", {
                        src: require('@/assets/image/icon/icon-change.png')
                      }, null, 8, _hoisted_31),
                      _createTextVNode(" 切换 ")
                    ])
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_router_link, {
                class: "btn-add-company",
                to: { name: 'binding-company' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), null, {
                    default: _withCtx(() => [
                      _createTextVNode("绑定")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.finance, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.label,
                class: "main-finance-content__item",
                onClick: ($event: any) => (handleRouterLink(item.path))
              }, [
                _createElementVNode("img", {
                  src: item.icon
                }, null, 8, _hoisted_38),
                _createElementVNode("span", null, _toDisplayString(item.label), 1)
              ], 8, _hoisted_37))
            }), 128))
          ])
        ]),
        _createVNode(_unref(Swipe), {
          class: "header-swipe",
          immediate: true,
          autoplay: 3000
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SwipeItem), null, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "invite-banner",
                  src: _imports_4,
                  alt: "",
                  onClick: handleRouterMember
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(SwipeItem), null, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  class: "invite-banner",
                  to: "/integral/mall/1"
                }, {
                  default: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.centerBannerList, (item) => {
              return (_openBlock(), _createBlock(_unref(SwipeItem), {
                key: item.imgUrl
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    class: "invite-banner",
                    href: item.linkUrl
                  }, [
                    _createVNode(MImage, {
                      src: item.imgUrl
                    }, null, 8, ["src"])
                  ], 8, _hoisted_40)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.bannerList, (item) => {
              return (_openBlock(), _createBlock(_unref(SwipeItem), {
                key: item.imgUrl
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    class: "invite-banner",
                    href: item.linkUrl
                  }, [
                    _createVNode(MImage, {
                      src: item.imgUrl
                    }, null, 8, ["src"])
                  ], 8, _hoisted_41)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(myServiceToolList), (item) => {
              return (_openBlock(), _createBlock(_unref(Badge), {
                key: item.label,
                class: "main-finance-content__item",
                onClick: ($event: any) => (handleRouterLink(item.path)),
                content: 
              item.label === '权益包' ? state.equityPackageUnReadNum : ''
            ,
                max: "99"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "third",
                    src: item.icon
                  }, null, 8, _hoisted_45),
                  _createElementVNode("span", null, _toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "content"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(myServiceList), (item) => {
              return (_openBlock(), _createBlock(_unref(Badge), {
                key: item.label,
                class: "main-finance-content__item",
                onClick: ($event: any) => (handleRouterLink(item.path)),
                content: 
              item.label === '权益包' ? state.equityPackageUnReadNum : ''
            ,
                max: "99"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "third",
                    src: item.icon
                  }, null, 8, _hoisted_49),
                  _createElementVNode("span", null, _toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "content"]))
            }), 128))
          ])
        ]),
        _hoisted_50
      ])
    ]),
    _createVNode(MTabbar)
  ], 64))
}
}

})